import { makeObservable, observable, runInAction } from 'mobx'
import i from '../../translations/i'

// Общее для экранов каталога: хлебные крошки текущей категории и счётчик товаров без категории.
// Списки категорий и товаров — в CategoryTable и ProductTable
class __catalog {

    productWithoutCategory: number = 0

    tree: {title: string, href?: string}[] = [
        { title: i.t('categories:catalog'), href: `/shop/catalog/category` }
    ]

    constructor() {
        makeObservable(this, {
            tree: observable,
            productWithoutCategory: observable,
        })
    }

    defaultTree(tree: any[]) {
      this.tree = [
        { title: i.t('categories:catalog'), href: `/shop/catalog/category` }
      ]

      tree.map((el: any) => this.tree.push({
        title: el.name,
        href: el.subcategories ? `/shop/catalog/category/${el.id}` : `/shop/products/${el.id}`
      }))
    }

    // Из ответа списка категорий или товаров: хлебные крошки и счётчик товаров без категории
    setMeta(result: any) {
        runInAction(() => {
            this.productWithoutCategory = result.product_without_category ?? 0
            this.defaultTree(result.breadcrumbs ?? [])
        })
    }
}

export default new __catalog()
